import { InjectionToken } from '@angular/core';
import { TProviderApi } from '@simOn/provider/connection/models';

export const MatterportAuthProviderApi = new InjectionToken<TProviderApi>('Provider api for save auth config');
